// removed by extract-text-webpack-plugin
module.exports = {"Form":"AYJbnCUfpskIu4reQF7eV","Field":"_2wEEQd3EySIPPmtgYbZHKI","Label":"_1pF1iomCvOSAvl_GJqQN8n","Input":"_2Vm0Gi2lKHOfaXbHD0ux9U","Select":"_2Rob8T3R2X_ve-7t9rILv-","Hint":"_1bkaSm1Hy4w3gWhn0lH3IU","Error":"_1-ZWT29HXNczVvB3b5d3hk","Actions":"_1Dj_uP-NqE2hMZi14YKyi2","Submit":"_3OL5yN0aDSVyO7b20VsIv_"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/ComponentsOfAdministrator/AntiFraudForm/styles.module.css
// module id = 533
// module chunks = 0